import styled from 'styled-components'
import {Box, Flex, PositionBox, TextBox} from 'landing/kit'
import { themeGet } from 'styled-system'
import citeBg from './assets/cite.svg'
import slider from './assets/slider.svg'

export const Container = styled(PositionBox)`
  width: calc(100% - 32px);
  max-width: 1140px;
  margin: 0 auto;
  position: relative;
  height: 100%;

  button {
    font-family: 'Montserrat', sans-serif;
  }
`
Container.defaultProps = {
  color: 'text'
}
export const H1 = styled(TextBox).attrs({ as: 'h1' })``
H1.defaultProps = {
  fontSize: {_: 48, md: 64},
  fontWeight: 'bold',
  lineHeight: {_: 1.1, md: 1},
  m: 0,
}
export const H2 = styled(TextBox).attrs({ as: 'h2' })``
H2.defaultProps = {
  fontSize: {_: 32, md: 48},
  fontWeight: 'bold',
  lineHeight: {_: 1.1, md: 1},
  m: 0,
}
export const H3 = styled(TextBox).attrs({ as: 'h3' })``
H3.defaultProps = {
  fontSize: {_: 28, md: 32},
  fontWeight: 'bold',
  lineHeight: {_: 1.1, md: 1.2},
  m: 0,
  color: 'text'
}
export const H4 = styled(TextBox).attrs({ as: 'h4' })`
  font-family: "Rock Salt", cursive;
`
H4.defaultProps = {
  fontSize: {_: 24, md: 36},
  lineHeight: 1.3,
  m: 0,
}
export const Text = styled(TextBox)`
  font-size: 24px;
  line-height: 1.4;
`
export const Cite = styled(Box)`
  background: rgba(12, 31, 134, 0.05);
  border-radius: 16px;
  font-weight: 600;
  font-style: italic;
  font-size: 24px;
  color: #0C1F86;
  background-image: url(${citeBg});
  background-repeat: no-repeat;
  background-position: 20px 0;
  p {
    margin: 0 0 20px;
  }
`
Cite.defaultProps = {
  padding: {_: '32px 40px 30px', lg: '40px 48px 30px'},
  my: {_: 20, lg: 40}
}
export const Card = styled(Box)`
  box-shadow: 0 42.27px 30.36px -36.61px rgba(90, 113, 142, 0.1);
  background-color: #fff;
  border-radius: 16px;
`

export const RangeInput = styled('input')`
  width: 80%;
  height: 1px;
  background: #eee;
  opacity: 1;
  outline: none;
  transition: 0.3s;
  -webkit-appearance: none;
  padding: 0 20px 0 20px;
  margin-bottom: 30px;

  &::-webkit-slider-thumb {
    appearance: none;
    -webkit-appearance: none;
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-image: ${'url(' + slider + ')'};
    background-color: transparent;
    cursor: pointer;
    box-shadow: none;
  }
`

export const PurpleBox = styled(Box)`
  background: #7223FA;
`

export const WhiteBox = styled(Flex)`
  background: #fff;
  padding: 38px 28px;
  box-shadow: 0 26.273px 38.359px -12.611px rgba(90, 113, 142, 0.10);
  border-radius: 16px;
  column-gap: 28px;
  row-gap: 28px;
  
  @media screen and (min-width: ${themeGet('breakpoints.lg')}) {
    padding: 56px;
  }
`
